import { createContext, useCallback, useContext, useState } from "react";

import { NotificationContext } from "providers/NotificationProvider";

export const ToastContext = createContext();
ToastContext.displayName = "Toast";
export const useToast = () => useContext(ToastContext);

const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);
    const addNotification = useContext(NotificationContext)?.addNotification;

    /**
     *  type: info (default), success, warning, error
     */
    const addToast = useCallback(
        ({ type = "info", duration = 3000, message }) => {
            const toast = {
                id: `${Date.now().toString()}_${type}`,
                type,
                duration,
                message,
            };

            setToasts((prev) => [...prev.slice(-2), toast]);
            addNotification?.({ type, message });
        },
        [addNotification]
    );

    const removeToast = useCallback(
        (id) => setToasts((prev) => prev.filter((toast) => toast.id !== id)),
        []
    );

    return (
        <ToastContext.Provider value={{ toasts, addToast, removeToast }}>
            {children}
        </ToastContext.Provider>
    );
};

export default ToastProvider;
